/* src/app/order/components/billing-information/billing-info-preview/billing-info-preview.style.scss */
.billing-container .address-toggle {
  display: flex;
}
.billing-container .address-toggle change-label {
  align-self: end;
  margin: 0 0 20px -10px;
}
.billing-container .details {
  padding: 20px 0 0 0;
}
.billing-container .toggle-row {
  padding: 40px 0 10px 0;
}
.billing-container .radio-row {
  flex-wrap: nowrap;
  flex-direction: column;
  padding: 20px 0 20px 0;
}
.billing-container .radio-row .radio-with-question {
  display: flex;
  flex-direction: column;
}
.billing-container .radio-row .radio-column {
  display: flex;
  align-items: center;
}
.billing-container .text-row .text-row-label {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  color: #007d40;
}
.billing-container .text-row .text-value {
  margin: 0;
  font-weight: bold;
}
.billing-container .text-row .placeholder {
  color: #8C8C8C;
}
.billing-container .purchase-label {
  display: block;
}
.billing-container .change-button {
  margin-top: 20px;
  float: right;
}
/*# sourceMappingURL=billing-info-preview.style.css.map */
